import { SET_NULL_VALUE } from './types';

export const setNullValue = nullValue => ({
  type: SET_NULL_VALUE, nullValue
});
